import { Component } from '@angular/core';
import { MessagingService } from './core/_services/messaging.service';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { environment } from 'src/environments/environment';
import { VersioncheckService } from './core/_services/versioncheck.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'client-admin-panel';
  message: any;
  constructor(private vcs: VersioncheckService, private messagingService: MessagingService, private angularFireMessaging: AngularFireMessaging) {
    this.messagingService.getPermission();
    this.messagingService.receiveMessage();
    this.message = this.messagingService.currentMessage;

    // You can also handle notifications directly in the constructor if needed
    this.angularFireMessaging.messages.subscribe(
      (payload: any) => {
        console.log(payload, 'payload')
      }
    );
  }
  async ngOnInit() {
    this.messagingService.receiveMessage();
    await this.loadGoogleMaps();
    // version check
    this.vcs.startVersionCheck();
    if (localStorage.getItem('fr')) {
      localStorage.removeItem('fr');
    }
  }

  loadGoogleMaps(): Promise<void> {
    const scriptId = 'google-maps-script';

    // If already loaded, resolve immediately
    if ((window as any).google && (window as any).google.maps) {
      return Promise.resolve();
    }

    // If the script is already injected, wait for it to load
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      return new Promise((resolve) => {
        existingScript.addEventListener('load', () => resolve());
      });
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places&v=weekly`;
      script.async = true;
      script.defer = true;

      script.onload = () => resolve();
      script.onerror = (err) => reject(err);

      document.body.appendChild(script);
    });
  }
  // ngOnDestroy() {
  //   this.messagingService.ngOnDestroy();
  // }
  ngOnDestroy() {
    this.vcs.destroyVersionCheck();
  }
}
